export enum HamburgerMenuCategory {
  INO,
  PUBLIC,
  EXIT,
}
